import Logger from '@/lib/logger';
import { AnalyticsEventListener } from '../types/analytics.types';

const logger = new Logger('AnalyticsEventBus');
const analyticsEventListeners = new Set<AnalyticsEventListener>();

export const addAnalyticsEventListener = (listener: AnalyticsEventListener) => {
  analyticsEventListeners.add(listener);
  return () => {
    analyticsEventListeners.delete(listener);
  };
};

export const notifyAnalyticsEventListeners = (
  eventName: string,
  properties: Record<string, unknown>
) => {
  for (const listener of analyticsEventListeners) {
    try {
      listener(eventName, properties);
    } catch (error) {
      logger.error('Analytics event listener failed', error);
    }
  }
};
